/* eslint-disable no-console */
/* eslint-disable max-len */
import { useState } from 'react';

export const Image = (props) =>
{
	const { src, alt, fallback, className } = props;
	const [ error, setError ] = useState(false);

	const onError = () =>
	{
		setError(true);
	};

	// eslint-disable-next-line react/react-in-jsx-scope
	return error ? fallback : <img src={src} alt={alt} onError={onError} className={className} loading='lazy' />;
};
